import { FormikValues } from 'formik';
import { enumValue, isAbnormalValue, isNormalValue, outOfRangeText } from '~/util';

export function detailCollectionValidation(
    collection: GapDetailType[],
    formik: FormikValues,
    getName: (x: GapDetailType) => null | string
) {
    if (collection.length === 1) {
        return 'Result is required.';
    }
    if (!collection.some((detail2) => !!formik.values[getName(detail2)!])) {
        return 'At least one result in this measure is required.';
    }
    return '';
}

export function detailValueValidation(
    value: string,
    detail: QualityMeasureDetailType,
    ratio?: string,
    name?: string
) {
    if (
        detail.data_type === enumValue(['gap', 'supplemental_value_data_types', 'Integer']) &&
        !Number.isInteger(Number(value))
    ) {
        return 'Result can only be an integer (whole number).';
    }

    if (
        detail.data_type === enumValue(['gap', 'supplemental_value_data_types', 'Decimal']) &&
        Number.isNaN(Number(value))
    ) {
        return 'Result must be a valid decimal number.';
    }

    if (
        detail.data_type === enumValue(['gap', 'supplemental_value_data_types', 'Ratio']) &&
        Number.isNaN(Number(value))
    ) {
        return 'Result must be a valid number.';
    }

    if (!isNormalValue(value, detail, ratio) && !isAbnormalValue(value, detail, ratio)) {
        return outOfRangeText(detail, false, name, ratio);
    }

    return '';
}
